import {i18n} from '@/plugins/i18n';
import {transmitDescription, transmitDescriptionStr} from '@/constants/transmitDescription';
import {transmitType, transmitTypeStr} from "@/constants/transmitType";

export default [
    {
        field: 'balance',
        title: i18n.t('label.amount_rial'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            let amount;

            if (row.debit === 0) {
                amount = row.credit;
            } else {
                amount = row.debit;
            }

            const pieces = parseFloat(amount).toFixed(0).split('');
            let ii = pieces.length;

            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ',');
            }

            return `<span>${pieces.join('')}</span>`;
        },
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            let type;

            if (row.debit === 0) {
                type = transmitTypeStr.get(transmitType.credit);
            } else {
                type = transmitTypeStr.get(transmitType.debit);
            }

            return `<span>${type}</span>`;
        },
    },
    {
        field: 'description',
        title: i18n.t('label.description'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            if (row.description === transmitDescription.reversal) {
                row.description = transmitDescriptionStr.get(transmitDescription.reversal);
            } else if (row.description === transmitDescription.paya_wage) {
                row.description = transmitDescriptionStr.get(transmitDescription.paya_wage);
            } else if (row.description === transmitDescription.paya) {
                row.description = transmitDescriptionStr.get(transmitDescription.paya);
            } else if (row.description === transmitDescription.internal) {
                row.description = transmitDescriptionStr.get(transmitDescription.internal);
            }

            return `<span>${row.description}</span>`;
        },
    },
    {
        field: 'time',
        title: i18n.t('label.date'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            let tr_date = row.transactionDate;

            const date_pieces = tr_date.split('').reverse();
            let date_ii = date_pieces.length;
            let date_limit = 4;

            while ((date_ii -= date_limit) > 0) {
                date_pieces.splice(date_ii, 0, '/');
                date_limit = 2;
            }

            tr_date = date_pieces.reverse().join('');
            let tr_time = row.transactionTime;

            const time_pieces = tr_time.split('');
            let time_ii = time_pieces.length;

            while ((time_ii -= 2) > 0) {
                time_pieces.splice(time_ii, 0, ':');
            }

            tr_time = time_pieces.join('');

            return `<span>${tr_time} ${tr_date}</span>`;
        },
    }
];